var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F2F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8328 12.6672C17.6099 12.4443 17.2484 12.4443 17.0255 12.6672L14.2894 15.4033L11.5533 12.6672C11.3304 12.4443 10.9689 12.4443 10.746 12.6672C10.5231 12.8901 10.5231 13.2516 10.746 13.4745L13.4821 16.2106C13.928 16.6565 14.6509 16.6565 15.0967 16.2106L17.8328 13.4745C18.0557 13.2516 18.0557 12.8901 17.8328 12.6672Z",
    fill: "#1A1C1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircle);
export default __webpack_public_path__ + "static/media/arrow-down-circle.105b01b2429754bddcaabc2fc538f334.svg";
export { ForwardRef as ReactComponent };